import {
  AppBar,
  Box,
  Container,
  Stack,
  Link as MuiLink,
  Toolbar,
} from '@mui/material';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

// IMGS
import logo from '../../images/logo-CompleteSMS.svg';

// COMPONENTS
import EnvBar from '../common/EnvBar';
import AccountMenu from '../navigation/AccountMenu';
import MobileNavigation from '../navigation/MobileNavigation';
import Navigation from '../navigation/Navigation';

export default function NavBar({
  accessLevel,
  accessType,
  actingNames,
  navBarInfo,
  handleImitationClear,
  handleLogout,
}) {
  const messages = {
    adminText: <FormattedMessage id="App.AdminLink" defaultMessage="Admin" />,
    billingText: (
      <FormattedMessage id="App.BillingLink" defaultMessage="Billing" />
    ),
    homeText: <FormattedMessage id="App.HomeLink" defaultMessage="Home" />,
    reportsText: (
      <FormattedMessage id="App.ReportsLink" defaultMessage="Reports" />
    ),
    userText: <FormattedMessage id="App.Account" defaultMessage="Account" />,
    webSMSText: <FormattedMessage id="App.SendSMS" defaultMessage="Send SMS" />,
  };

  const sections =
    accessLevel === '3' && accessType === '3'
      ? [
          { text: messages.webSMSText, link: '/websms/compose' },
          { text: messages.userText, link: '/account/administrators' },
          { text: messages.reportsText, link: '/reports/cost-center' },
          { text: messages.billingText, link: '/billing/invoices' },
          { text: messages.adminText, link: '/admin/find-customer' },
        ]
      : accessLevel > '0' && accessType !== '0'
      ? [
          { text: messages.webSMSText, link: '/websms/compose' },
          { text: messages.userText, link: '/account/administrators' },
          { text: messages.reportsText, link: '/reports/cost-center' },
          { text: messages.billingText, link: '/billing/invoices' },
        ]
      : [{ text: messages.webSMSText, link: '/websms/compose' }];

  // Return no header on customer verify
  if (window.location.href.includes('/customer/verify')) return null;

  return (
    <AppBar
      position="static"
      className="header"
      elevation={3}
      sx={{
        backgroundColor: 'common.white',
        borderBottom: '1px solid',
        borderColor: 'primary.main',
        color: 'inherit',
        boxShadow:
          '0px 3px 3px -2px rgba(0, 0, 0, 0.05), 0px 3px 4px 0px rgba(0, 0, 0, 0.05), 0px 1px 8px 0px rgba(0, 0, 0, 0.05)',
      }}
    >
      <MuiLink
        sx={{
          left: 0,
          paddingX: 2,
          position: 'absolute',
          transform: 'translateY(-110%)',
          transition: 'transform 0.3s',
          '&:focus': {
            position: 'relative  ',
            transform: 'translateY(0%)',
          },
        }}
        href="#content"
      >
        Skip Navigation
      </MuiLink>

      {(process.env.REACT_APP_ENV !== 'production' ||
        (accessLevel === '3' && accessType === '3')) && (
        <EnvBar
          accessLevel={accessLevel}
          accessType={accessType}
          customer={actingNames.customer_name}
          provider={actingNames.provider_name}
        />
      )}

      <Container
        maxWidth="false"
        sx={{ paddingY: 1, paddingX: 2 }}
        disableGutters
      >
        <Toolbar disableGutters>
          <MobileNavigation sections={sections} />

          <Stack
            sx={{
              flexGrow: { xs: 1, md: 0 },
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Box
              sx={{
                height: { xs: 40, md: 46 },
                width: { xs: 172, md: 192 },
              }}
            >
              <Link to="/home">
                <img src={logo} alt="CompleteSMS" height="100%" width="100%" />
              </Link>
            </Box>
          </Stack>

          <Navigation sections={sections} />

          <Stack
            sx={{
              flexGrow: { xs: 0, md: 1 },
              justifyContent: 'flex-end',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: 2,
            }}
          >
            <AccountMenu
              accessLevel={accessLevel}
              accessType={accessType}
              navBarInfo={navBarInfo}
              account={actingNames}
              handleImitationClear={handleImitationClear}
              handleLogout={handleLogout}
            />
          </Stack>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
